import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { useLocation, useParams } from 'react-router-dom';
import { PuffLoader, PulseLoader } from 'react-spinners';
import { SupplierDetailApi } from '../redux/actions/User/Detail/SupplierDetailAction';
import backend_url from '../services/endpoints';
import { useHeading } from '../context/HeadingContext';
import { CustomerRestaurantDetailApi } from '../redux/actions/User/Detail/CustomerRestaurantDetailAction';
import { formatDate, formatTime12Hour } from '../helpers/formatDateTime';
import { ChangeOrderStatusAPI } from '../redux/actions/User/Detail/ChangeOrderStatusAction';
import { changeOrderStatusStateReset } from '../redux/slices/User/Detail/ChangeOrderStatusSlice';
import { CustomerRestaurantCompletedOrdersApi } from '../redux/actions/User/Detail/GetCustomerRestaurantCompletedOrdersAction';

const CustomerRestaurantDetail = () => {

    const { id } = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const { setHeading } = useHeading();
    const { response, error, loading } = useSelector((state) => state.getSupplierDetail);

    const { response: ordersResponse, error: ordersError, loading: ordersLoading } = useSelector((state) => state.customerRestaurantDetail);

    const { response: completedOrdersResponse, error: completedOrdersError, loading: completedOrdersLoading } = useSelector((state) => state.customerRestaurantCompleteOrders);

    const { response: changeOrderStatusResponse, error: changeOrderStatusError } = useSelector((state) => state.changeOrderStatus);

    //request generated pagination params
    const [page1, setPage1] = useState(1);
    const [limit1, setLimit1] = useState(5);

    //completed orders pagination params
    const [page2, setPage2] = useState(1);
    const [limit2, setLimit2] = useState(5);

    const [selectedOrder, setSelectedOrder] = useState(null);
    // const [showDateTimeFields, setShowDateTimeFields] = useState(false);
    const [showInput, setShowInput] = useState(false);
    const [deliveryCharges, setDeliveryCharges] = useState('');

    const handleClick = () => {
        setShowInput(true);
    };

    const handleChange = (e) => {
        setDeliveryCharges(e.target.value);
    };

    const handleBlur = () => {
        if (deliveryCharges !== '') {
            // Update selectedOrder with new charge
            setSelectedOrder(prev => ({
                ...prev,
                deliveryCharges: Number(deliveryCharges)
            }));
        }

        setShowInput(false); // Hide input
    };


    const fetchDetail = useCallback(() => {
        dispatch(SupplierDetailApi(id));
    }, [dispatch, id]);

    const fetchOrders = useCallback((type) => {

        let params = {};
        if (type === 1) {
            params = { userId: id, page: page1, limit: limit1, type: 1 }
        }
        // else if (type === 2) {
        //     params = { userId: id, page: page2, limit: limit2, type: 2 }
        // }
        // else if (type === 3) {
        //     params = { userId: id, page: page2, limit: limit2, type: 3 }
        // }
        dispatch(CustomerRestaurantDetailApi(params));
    }, [dispatch, page1, limit1]);

    const fetchCompletedOrders = useCallback((type) => {

        let params = { userId: id, page: page2, limit: limit2, type: type }
        dispatch(CustomerRestaurantCompletedOrdersApi(params));

    }, [dispatch, page2, limit2]);

    const getOrderStatus = (t) => {
        if (t == 0 || t == 7) {
            return 'Pending'
        }
        else if (t == 1) {
            return 'Accepted'
        }
        else if (t == 2) {
            return 'Rejected'
        }
        else if (t == 3) {
            return 'Cancelled'
        }
        else if (t == 4) {
            return 'Payment Pending'
        }
        else if (t == 5) {
            return 'Completed'
        }
        else if (t == 6) {
            return 'Reported'
        }
    }

    const handleRejectOrderRequest = async (orderId, status) => {
        try {
            const data = {
                orderId: orderId,
                status: status
            }
            dispatch(ChangeOrderStatusAPI(data))
        } catch (error) {
            console.log('error in reject order request', error)
        }
    }

    const handleAcceptOrderRequest = async (orderId, status) => {
        try {
            const data = {
                orderId: orderId,
                status: status,
                deliveryCharges: 0
            }
            dispatch(ChangeOrderStatusAPI(data))
        } catch (error) {
            console.log('error in reject order request', error)
        }
    }

    useEffect(() => {
        const modalElement = document.getElementById('detailModal2');

        const handleModalHide = () => {
            setShowInput(false);
            setDeliveryCharges('');
        }
        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleModalHide);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleModalHide);
            }
        };
    }, []);

    useEffect(() => {
        fetchDetail(id);
    }, [location, id]);

    useEffect(() => {
        if (response?.data?.supplier?.firstName) {
            setHeading(response.data.supplier.firstName);
        }
        else {
            setHeading(""); // Reset heading if no ownerName
        }
    }, [response, setHeading]);

    useEffect(() => {
        fetchOrders(1);
        // fetchOrders(2);
        fetchCompletedOrders(3);
    }, [response, fetchOrders, fetchCompletedOrders]);

    useEffect(() => {
        if (ordersResponse?.status === true) {
            setPage1(ordersResponse?.data?.page);
            setLimit1(ordersResponse?.data?.limit)
        }
    }, [ordersResponse])

    useEffect(() => {
        if (completedOrdersResponse?.status === true) {
            setPage2(completedOrdersResponse?.data?.page);
            setLimit2(completedOrdersResponse?.data?.limit)
        }
    }, [completedOrdersResponse])

    // useEffect(() => {
    //     if (getSuppliersRequestGeneratedResponse?.status === true) {
    //         setPage1(getSuppliersRequestGeneratedResponse?.data?.page);
    //         setLimit1(getSuppliersRequestGeneratedResponse?.data?.limit);

    //         setPage2(getSuppliersRequestGeneratedResponse?.data?.page);
    //         setLimit2(getSuppliersRequestGeneratedResponse?.data?.limit);
    //     }
    // }, [getSuppliersRequestGeneratedResponse])

    useEffect(() => {
        if (changeOrderStatusResponse?.status === true) {
            showSuccessToast(changeOrderStatusResponse?.message);
            dispatch(changeOrderStatusStateReset());
            fetchDetail(id);
            fetchOrders(1);
            fetchCompletedOrders(2);
            const modalElement = document.getElementById('detailModal2');
            if (modalElement) {
                let modal = window.bootstrap.Modal.getInstance(modalElement);
                if (!modal) {
                    modal = new window.bootstrap.Modal(modalElement);
                }
                modal.hide();
            } else {
                console.warn("Modal element with ID 'detailModal2' not found in DOM.");
            }
            setDeliveryCharges('')
        }
    }, [changeOrderStatusResponse, fetchDetail, fetchOrders, fetchCompletedOrders, dispatch]);

    useEffect(() => {
        if (error) {
            showErrorToast(error?.data || "Something went wrong");
        }
        if (ordersError) {
            showErrorToast(ordersError?.data || "Something went wrong");
        }
        if (completedOrdersError) {
            showErrorToast(completedOrdersError?.data || "Something went wrong");
        }
        if (changeOrderStatusError) {
            showErrorToast(changeOrderStatusError?.data);
            dispatch(changeOrderStatusStateReset())
        }
    }, [error, ordersError, changeOrderStatusError, completedOrdersError]);

    return (
        <>
            {loading ? (
                <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center text-center'>
                    <PulseLoader size={85} color="#0f0a30" />
                </div>
            ) : (
                <section className='main'>
                    <div className='container'>
                        <div className='row gy-4'>
                            <div className='col-12'>
                                <div className="wrapper-card">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className='hstack flex-wrap gap-3'>
                                                <div className='supp_img'>
                                                    <img src={response?.data?.supplier?.image ? `${backend_url}${response?.data?.supplier?.image}` : '/assets/images/user.png'} alt="profile_image" />
                                                </div>
                                                <div className="info_content">
                                                    <div className='supplier_name_blk mb-3'>
                                                        <h3 className='fw-bold mb-0'>{response?.data?.supplier?.firstName || 'N/A'}</h3>
                                                    </div>
                                                    <div className="info_content-row hstack flex-wrap">
                                                        <div className="info-detail">
                                                            <h2 className="h4">Location</h2>
                                                            <p className="mb-0">{[
                                                                response?.data?.supplier?.street,
                                                                response?.data?.supplier?.city,
                                                                response?.data?.supplier?.state,
                                                                response?.data?.supplier?.country
                                                            ]
                                                                .filter(Boolean)  // removes undefined, null, empty string
                                                                .join(", ")}</p>
                                                        </div>
                                                        <div className="info-detail">
                                                            <h2 className="h4">Contact Number</h2>
                                                            <p className="mb-0">{response?.data?.supplier?.phoneNumber || 'N/A'}</p>
                                                        </div>
                                                        <div className="info-detail">
                                                            <h2 className="h4">Email Address</h2>
                                                            <p className="mb-0">{response?.data?.supplier?.email || 'N/A'}</p>
                                                        </div>
                                                        {/* <div className="info-detail">
                                                        <h2 className="h4">Type of Product</h2>
                                                        <p className="mb-0">{response?.data?.supplier?.product || 'N/A'}</p>
                                                    </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12'>
                                <div className='wrapper-card income_card d-inline-flex flex-column align-items-center'>
                                    <span className='income_title'>Total Income</span>
                                    <span className='income_amount'>{`$0`}</span>
                                </div>
                            </div>
                            <div className='col-12'>
                                <div className='common_tabs'>
                                    <nav>
                                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                            <button className="nav-link active" id="nav-cmt-1-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-1" type="button" role="tab" aria-controls="nav-cmt-1" aria-selected="true">Request Generated</button>
                                            <button className="nav-link" id="nav-cmt-2-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-2" type="button" role="tab" aria-controls="nav-cmt-2" aria-selected="false">Completed Orders</button>
                                        </div>
                                    </nav>
                                    < div className="tab-content wrapper-card" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-cmt-1" role="tabpanel" aria-labelledby="nav-cmt-1-tab" tabIndex={0}>
                                            <div className='outer_product_card_wrapper hstack align-items-start flex-wrap gap-4 mt-4'>
                                                {Array.isArray(ordersResponse?.data?.orders) && ordersResponse?.data?.orders?.length > 0 ? (
                                                    ordersResponse?.data?.orders?.map((order, index) => {
                                                        return (
                                                            <div className='outline_product_card_list'>
                                                                <div className='product_card_header hstack justify-content-between gap-3'>
                                                                    <h2 className='h5 fw-bold mb-0'>
                                                                        {order.requestedProducts.length} Product{order.requestedProducts.length > 1 ? 's' : ''}
                                                                    </h2>
                                                                    <div className='d-flex flex-end gap-2'>
                                                                        <span className='status_badge date_badge'>  {new Date(order.createdAt).toLocaleDateString('en-US', {
                                                                            day: 'numeric',
                                                                            month: 'short',
                                                                            year: 'numeric',
                                                                        })}</span>
                                                                        <span className='status_badge badge_pending'>{getOrderStatus(order?.status)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='inner_outline_card hstack align-items-start'>
                                                                    {order.requestedProducts.map((product, i) => (
                                                                        <div className='product_item hstack align-items-start'>
                                                                            <div className='product_img'>
                                                                                <img src={product?.image ? `${backend_url}${product?.image}` : '/assets/images/fruit-apple.png'} alt={product?.productName} />
                                                                            </div>
                                                                            <div className='product_info'>
                                                                                <div className='product_title_blk'>
                                                                                    <h3 className='product_name fs-6 fw-bold mb-0'>{product?.productName}</h3>
                                                                                </div>
                                                                                <ul className='product_title_info list-unstyled mb-0'>
                                                                                    <li><span className='card_product_title fw-medium'>Quantity -</span><span className='card_value'>{product?.quantity}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Type -</span><span className='card_value'>{product?.productType}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Price -</span><span className='card_value'> {product.price ? (product.unitType ? `$${product.price}/${product.unitType}` : `$${product.price}`) : "N/A"}</span></li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className='product_total_blk hstack justify-content-between gap-3'>
                                                                    <h3 className='fs-6 fw-medium mb-0'>Total - {`$${order.totalPrice}`} </h3>

                                                                    {/* for now details button is disbaled */}
                                                                    <div className='d-flex flex-end gap-2'>
                                                                        <button className='primary-btn' data-bs-toggle="modal" data-bs-target="#detailModal2" onClick={() => setSelectedOrder(order)}>Details</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })) :
                                                    <h2 className='h5 my-4'>No requests</h2>
                                                }

                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="nav-cmt-2" role="tabpanel" aria-labelledby="nav-cmt-2-tab" tabIndex={0}>
                                            <div className='outer_product_card_wrapper hstack align-items-start flex-wrap gap-4 mt-4'>
                                                {Array.isArray(completedOrdersResponse?.data?.orders) && completedOrdersResponse?.data?.orders?.length > 0 ? (
                                                    completedOrdersResponse?.data?.orders?.map((order, index) => {
                                                        return (
                                                            <div className='outline_product_card_list'>
                                                                <div className='product_card_header hstack justify-content-between gap-3'>
                                                                    <h2 className='h5 fw-bold mb-0'>
                                                                        {order.requestedProducts.length} Product{order.requestedProducts.length > 1 ? 's' : ''}
                                                                    </h2>
                                                                    <div className='d-flex flex-end gap-2'>
                                                                        <span className='status_badge date_badge'>  {new Date(order.createdAt).toLocaleDateString('en-US', {
                                                                            day: 'numeric',
                                                                            month: 'short',
                                                                            year: 'numeric',
                                                                        })}</span>
                                                                        <span className='status_badge badge_pending'>{getOrderStatus(order?.status)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='inner_outline_card hstack align-items-start'>
                                                                    {order.requestedProducts.map((product, i) => (
                                                                        <div className='product_item hstack align-items-start'>
                                                                            <div className='product_img'>
                                                                                <img src={product?.image ? `${backend_url}${product?.image}` : '/assets/images/fruit-apple.png'} alt={product?.productName} />
                                                                            </div>
                                                                            <div className='product_info'>
                                                                                <div className='product_title_blk'>
                                                                                    <h3 className='product_name fs-6 fw-bold mb-0'>{product?.productName}</h3>
                                                                                </div>
                                                                                <ul className='product_title_info list-unstyled mb-0'>
                                                                                    <li><span className='card_product_title fw-medium'>Quantity -</span><span className='card_value'>{product?.quantity}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Type -</span><span className='card_value'>{product?.productType}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Price -</span><span className='card_value'> {product.price ? (product.unitType ? `$${product.price}/${product.unitType}` : `$${product.price}`) : "N/A"}</span></li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className='product_total_blk hstack justify-content-between gap-3'>
                                                                    <h3 className='fs-6 fw-medium mb-0'>Total - {`$${order.totalPrice}`} </h3>

                                                                    {/* for now details button is disbaled */}
                                                                    {/* <div className='d-flex flex-end gap-2'>
                                                                        <button className='primary-btn' data-bs-toggle="modal" data-bs-target="#detailModal2" onClick={() => setSelectedOrder(order)}>Details</button>
                                                                    </div> */}
                                                                </div>
                                                            </div>
                                                        )
                                                    })) :
                                                    <h2 className='h5 my-4'>No orders</h2>
                                                }

                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* <detail modal 2> */}
                    {/* <div className="modal fade" id="detailModal2" tabIndex={-1} aria-labelledby="detailModal2Label" aria-hidden="true" inert> */}
                    <div className="modal fade" id="detailModal2" tabIndex={-1} aria-labelledby="detailModal2Label" aria-hidden="true" >
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-2 fw-bold text-black" id="detailModal2Label">Order Details</h1>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                {selectedOrder &&
                                    <div className="modal-body detail-modal-body p-4">
                                        <div className='outline_product_card_list'>
                                            <div className='product_card_header hstack justify-content-between gap-3'>
                                                <h2 className='h5 fw-bold mb-0'>
                                                    {selectedOrder?.requestedProducts?.length} Product{selectedOrder?.requestedProducts?.length > 1 ? 's' : ''}
                                                </h2>
                                                <div className='d-flex flex-end gap-2'>
                                                    <span className='status_badge date_badge'>{new Date(selectedOrder?.createdAt).toLocaleDateString('en-US', {
                                                        day: 'numeric',
                                                        month: 'short',
                                                        year: 'numeric',
                                                    })}</span>
                                                    <span className='status_badge badge_pending'>{getOrderStatus(selectedOrder?.status)}</span>
                                                </div>
                                            </div>
                                            {selectedOrder?.requestedProducts?.length > 0 && selectedOrder?.requestedProducts?.map((product, i) => (
                                                <div className='outline_flex hstack flex-wrap gap-3'>
                                                    <div className='inner_outline_card hstack align-items-start m-0'>
                                                        <div className='product_item hstack align-items-start'>
                                                            <div className='product_img'>
                                                                <img src={product?.image ? `${backend_url}${product?.image}` : '/assets/images/fruit-apple.png'} alt={product?.productName} />
                                                            </div>
                                                            <div className='product_info'>
                                                                <div className='product_title_blk'>
                                                                    <h3 className='product_name fs-6 fw-bold mb-0'>{product?.productName}</h3>
                                                                </div>
                                                                <ul className='product_title_info list-unstyled mb-0'>
                                                                    <li><span className='card_product_title fw-medium'>Quantity -</span><span className='card_value'>{product.quantity}</span></li>
                                                                    <li><span className='card_product_title fw-medium'>Type -</span><span className='card_value'>{product.productType}</span></li>
                                                                    <li><span className='card_product_title fw-medium'>Price -</span><span className='card_value'>{product.price ? (product.unitType ? `$${product.price}/${product.unitType}` : `$${product.price}`) : "N/A"}</span></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className='product_card_header hstack justify-content-between gap-3 pb-0'>
                                                <h2 className='h5 fw-bold mb-0'>Scheduled Time</h2>
                                            </div>
                                            <div className='outline_flex scheduled_time_wrapper'>
                                                <div className='outline_product_card_list'>
                                                    <div className='scheduled_time_mdl_blk'>
                                                        <div className='product_info_blk hstack justify-content-between gap-3'>
                                                            <h3 className='fs-14 fw-medium mb-0'>Date</h3>
                                                            <span>-</span>
                                                            <p className='fs-14 fw-medium mb-0 text-end'>{formatDate(selectedOrder?.scheduledDate)}</p>
                                                        </div>
                                                        <div className='product_info_blk hstack justify-content-between gap-3'>
                                                            <h3 className='fs-14 fw-medium mb-0'>Expected Time</h3>
                                                            <span>-</span>
                                                            <p className='fs-14 fw-medium mb-0 text-end'>{formatTime12Hour(selectedOrder?.scheduledTime)}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='outline_flex '>
                                                <div className='outline_product_card_list'>
                                                    <div className='product_card_header hstack justify-content-between gap-3'>
                                                        <h2 className='h5 fw-bold mb-0'>Order Summary</h2>
                                                    </div>
                                                    <div className=''>
                                                        <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                            <h3 className='fs-14 fw-medium mb-0'>Sub Total  </h3>
                                                            <p className='fs-14 fw-medium mb-0'>${selectedOrder?.totalPrice}</p>
                                                        </div>
                                                        <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                            <h3 className='fs-14 fw-medium mb-0'>Delivery </h3>
                                                            <p
                                                                className="fs-14 fw-medium mb-0"
                                                            >
                                                                ${selectedOrder?.deliveryCharges || 0}
                                                            </p>

                                                            {/* {!showInput && selectedOrder.deliveryCharges == 0 && (selectedOrder?.status == 0 || selectedOrder?.status == 7) ? (
                                                                <p
                                                                    className="fs-14 fw-medium mb-0"
                                                                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                                    onClick={handleClick}
                                                                >
                                                                    Add delivery charges
                                                                </p>
                                                            ) : !showInput ? (
                                                                <p
                                                                    className="fs-14 fw-medium mb-0"
                                                                    onClick={(selectedOrder?.status == 0 || selectedOrder?.status == 7) ? handleClick : undefined}
                                                                    style={{ cursor: 'pointer' }} // Allow editing again
                                                                >
                                                                    ${selectedOrder.deliveryCharges}
                                                                </p>
                                                            ) : (
                                                                <input
                                                                    type="number"
                                                                    value={deliveryCharges}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    autoFocus
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Enter charge"
                                                                />
                                                            )} */}
                                                        </div>
                                                    </div>
                                                    <div className='product_total_blk hstack justify-content-between gap-3'>
                                                        <h3 className='fs-6 fw-medium mb-0'>Total</h3>
                                                        {/* <p className='fs-6 fw-medium mb-0'>${deliveryCharges ? (selectedOrder?.totalPrice + parseInt(deliveryCharges)) : selectedOrder?.totalPrice}</p> */}
                                                        <p className='fs-6 fw-medium mb-0'>${selectedOrder?.totalPrice || 0}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {(selectedOrder?.status == 0 || selectedOrder?.status == 7) &&
                                                (
                                                    <div className='modal_btn d-flex justify-content-end gap-2'>
                                                        <button className='transparent-btn fs-14 py-2' onClick={() => handleRejectOrderRequest(selectedOrder._id, 2)}>Reject</button>
                                                        <button className='primary-btn fs-14 py-2' onClick={() => {
                                                            // Call the API with required data
                                                            handleAcceptOrderRequest(selectedOrder._id, 1);
                                                        }}>Accept</button>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                    {/* <--------> */}
                </section >

            )}
        </>
    )
}

export default CustomerRestaurantDetail;